/* eslint-disable react/no-array-index-key */
/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import Table from '../../../components/Table/Table';
import TableContainer from '../../../components/TableContainer/TableContainer';
import TableBody from '../../../components/TableBody/TableBody';
import TableRow from '../../../components/TableRow/TableRow';
import TableCell from '../../../components/TableCell/TableCell';
import TableBtnSets from '../../../components/ConfigTable/TableBtnSets';
import TableHead from '../../../components/TableHead/TableHead';
import Typography from '../../../components/Typography/Typography';

const SettingConfigControlledFormingElNoTableHeadCells = [
  { id: 'productName', numeric: false, disablePadding: true, label: '產品名稱' },
  { id: 'elNo', numeric: false, disablePadding: true, label: '料號' },
  { id: 'materialName', numeric: false, disablePadding: true, label: '材質' },
];

const ControlledFormingElNoConfigTable = ({
  tableContentList,
  editedData,
  onRowDelete,
  isLoading,
}) => {
  const handleDelete = (targetRow) => {
    onRowDelete(targetRow);
  };

  return (
    <TableContainer isLoading={isLoading}>
      <Table>
        <TableHead
          isCheckBox={false}
          headCells={SettingConfigControlledFormingElNoTableHeadCells}
        />
        <TableBody>
          {tableContentList.length === 0 && (
            <TableRow>
              <TableCell colSpan={4}>
                <Typography variant="subtitle1" sx={{ textAlign: 'center' }}>
                  目前沒有管制壓型規格設定，請點擊新增
                </Typography>
              </TableCell>
            </TableRow>
          )}
          {tableContentList.map((row) => (
            <TableRow
              tabIndex={-1}
              key={row.rowId}
              style={{ verticalAlign: editedData?.error ? 'top' : 'middle' }}
            >
              <TableCell>{row.productName}</TableCell>
              <TableCell>{row.elNo}</TableCell>
              <TableCell>{row.materialName}</TableCell>
              <TableCell align="right">
                <TableBtnSets
                  isDelete
                  handleDelete={() => handleDelete(row)}
                  canDelete
                  canEdit={false}
                  deleteConfirmMessage={`是否確認刪除 ${row.elNo} 的管制壓型規格設定？`}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

ControlledFormingElNoConfigTable.defaultProps = {
  onRowDelete: null,
};

ControlledFormingElNoConfigTable.propTypes = {
  onRowDelete: PropTypes.func,
  isLoading: PropTypes.bool,
  tableContentList: PropTypes.array.isRequired,
  editedData: PropTypes.object,
};

export default ControlledFormingElNoConfigTable;
